import React, { useState, useEffect } from "react";
import { IoArrowUpOutline } from "react-icons/io5";

const Scroll = () => {
  const [isVisible, setIsVisible] = useState(false);

  const goToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  useEffect(() => {
    const onScroll = () => setIsVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      onClick={goToTop}
      aria-label="Scroll to top"
      className={`fixed bottom-14 right-4 z-[900] flex h-10 w-10 items-center justify-center rounded-full bg-blue-700 text-white shadow-lg shadow-blue-900/30 transition-all duration-300 hover:bg-blue-800 hover:-translate-y-0.5 active:scale-95 ${
        isVisible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <IoArrowUpOutline className="text-lg" />
    </button>
  );
};

export default Scroll;
